/* Tickle Cart theme scripts — vanilla JS, no third-party runtime dependencies. */
(function () {
  "use strict";

  var routes = window.themeRoutes || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart.js", predictive_search: "/search/suggest.json" };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, sel, handler) {
    if (!el) return;
    if (typeof sel === "function") { el.addEventListener(evt, sel); return; }
    el.addEventListener(evt, function (e) {
      var target = e.target.closest(sel);
      if (target && el.contains(target)) handler(e, target);
    });
  }

  /* A close/open control is often an <a> with a real destination (View cart,
     Continue shopping). Cancelling its default would close the overlay and go
     nowhere, so only preventDefault for non-navigating controls. */
  function isNavigatingLink(el) {
    if (!el || el.tagName !== "A") return false;
    var href = el.getAttribute("href");
    if (!href || href === "#" || href.indexOf("javascript:") === 0) return false;
    return true;
  }
  function suppress(e, el) { if (!isNavigatingLink(el)) e.preventDefault(); }

  /* ---------------- Mobile menu ---------------- */
  var mobileMenu = qs("#mobile-menu");
  on(document, "click", "[data-open-mobile-menu]", function (e) {
    e.preventDefault();
    if (mobileMenu) { mobileMenu.classList.add("is-open"); document.body.style.overflow = "hidden"; }
  });
  on(document, "click", "[data-close-mobile-menu]", function (e, el) {
    suppress(e, el);
    if (mobileMenu) { mobileMenu.classList.remove("is-open"); document.body.style.overflow = ""; }
  });
  on(mobileMenu, "click", ".mobile-menu__link[data-has-submenu]", function (e, target) {
    e.preventDefault();
    var item = target.closest(".mobile-menu__item");
    var submenu = qs(".mobile-menu__submenu", item);
    if (submenu) {
      var open = submenu.classList.toggle("is-open");
      item.classList.toggle("is-open", open);
    }
  });

  /* ---------------- Desktop mega menu ---------------- */
  qsa(".nav-list > li").forEach(function (li) {
    var trigger = qs(".nav-list__link", li);
    if (!trigger || !qs(".mega-menu", li)) return;
    trigger.setAttribute("aria-expanded", "false");
    li.addEventListener("mouseenter", function () { li.classList.add("is-open"); trigger.setAttribute("aria-expanded", "true"); });
    li.addEventListener("mouseleave", function () { li.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); });
    trigger.addEventListener("click", function (e) {
      if (trigger.getAttribute("href") === "#" || !trigger.getAttribute("href")) e.preventDefault();
      var isOpen = li.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { li.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); }
    });
  });
  document.addEventListener("click", function (e) {
    qsa(".nav-list > li.is-open").forEach(function (li) {
      if (!li.contains(e.target)) li.classList.remove("is-open");
    });
  });

  /* ---------------- Announcement bar carousel ---------------- */
  qsa("[data-announcement-bar]").forEach(function (bar) {
    var items = qsa(".announcement-bar__item", bar);
    if (items.length < 2) return;
    var index = 0;
    function show(i) {
      items.forEach(function (item, n) { item.classList.toggle("is-active", n === i); });
    }
    qs(".announcement-bar__nav--next", bar) && qs(".announcement-bar__nav--next", bar).addEventListener("click", function () {
      index = (index + 1) % items.length; show(index);
    });
    qs(".announcement-bar__nav--prev", bar) && qs(".announcement-bar__nav--prev", bar).addEventListener("click", function () {
      index = (index - 1 + items.length) % items.length; show(index);
    });
    var delay = parseInt(bar.getAttribute("data-autoplay-speed") || "5000", 10);
    if (delay > 0) {
      setInterval(function () { index = (index + 1) % items.length; show(index); }, delay);
    }
  });

  /* ---------------- Horizontal carousel controls ---------------- */
  qsa("[data-carousel]").forEach(function (wrap) {
    var track = qs(".carousel", wrap);
    if (!track) return;
    var prev = qs("[data-carousel-prev]", wrap);
    var next = qs("[data-carousel-next]", wrap);
    function scrollAmount() { return track.clientWidth * 0.8; }
    prev && prev.addEventListener("click", function () { track.scrollBy({ left: -scrollAmount(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { track.scrollBy({ left: scrollAmount(), behavior: "smooth" }); });
  });

  /* ---------------- Accordions ---------------- */
  on(document, "click", "[data-accordion-trigger]", function (e, trigger) {
    var item = trigger.closest(".accordion__item");
    var panel = qs(".accordion__panel", item);
    var isOpen = item.classList.contains("is-open");
    if (item.closest(".accordion").hasAttribute("data-single-open")) {
      qsa(".accordion__item.is-open", item.closest(".accordion")).forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove("is-open");
          qs(".accordion__panel", openItem).style.maxHeight = null;
          qs("[data-accordion-trigger]", openItem).setAttribute("aria-expanded", "false");
        }
      });
    }
    item.classList.toggle("is-open", !isOpen);
    trigger.setAttribute("aria-expanded", (!isOpen).toString());
    panel.style.maxHeight = !isOpen ? panel.scrollHeight + "px" : null;
  });

  /* ---------------- Quantity selectors ---------------- */
  on(document, "click", "[data-qty-decrease]", function (e, btn) {
    var input = btn.parentElement.querySelector("input[type='number']");
    var min = parseInt(input.min || "1", 10);
    var val = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
  on(document, "click", "[data-qty-increase]", function (e, btn) {
    var input = btn.parentElement.querySelector("input[type='number']");
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var val = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------- Variant picker (pills) ---------------- */
  qsa("[data-variant-picker]").forEach(function (form) {
    var variantsJson = form.querySelector("[data-variants-json]");
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (err) { return; }
    var idInput = form.querySelector("[data-variant-id-input]");
    var priceEl = qs("[data-product-price]", form.closest("[data-product-root]") || document);
    var comparePriceEl = qs("[data-product-compare-price]", form.closest("[data-product-root]") || document);
    var addBtn = qs("[data-add-to-cart]", form);
    var buyNowBtn = qs("[data-buy-now]", form);

    function getSelectedOptions() {
      var selected = [];
      qsa("[data-option-index]", form).forEach(function (group) {
        var index = parseInt(group.getAttribute("data-option-index"), 10);
        var checked = group.querySelector("input:checked");
        selected[index] = checked ? checked.value : null;
      });
      return selected;
    }

    function findVariant(selected) {
      /* Products with only a default variant render no option groups, so there is
         nothing to match on. Fall back to the variant the form already points at. */
      if (!selected.length) {
        var currentId = idInput ? parseInt(idInput.value, 10) : NaN;
        return variants.filter(function (v) { return v.id === currentId; })[0] || variants[0];
      }
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return (window.themeMoneyFormat || "Rs. {{amount}}").replace("{{amount}}", value);
    }

    function updateAvailability(selected) {
      qsa("[data-option-index]", form).forEach(function (group) {
        var index = parseInt(group.getAttribute("data-option-index"), 10);
        qsa("input", group).forEach(function (input) {
          var testSelection = selected.slice();
          testSelection[index] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (opt, i) { return testSelection[i] == null || opt === testSelection[i]; }); });
          input.disabled = !match;
        });
      });
    }

    function onChange() {
      var selected = getSelectedOptions();
      updateAvailability(selected);
      var variant = findVariant(selected);
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        var available = variant.available;
        [addBtn, buyNowBtn].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !available;
          btn.textContent = available ? btn.getAttribute("data-label-available") : btn.getAttribute("data-label-unavailable");
        });
        document.dispatchEvent(new CustomEvent("variant:changed", { detail: { variant: variant, form: form } }));
      } else {
        [addBtn, buyNowBtn].forEach(function (btn) { if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute("data-label-unavailable"); } });
      }
    }

    on(form, "change", "input[type='radio']", onChange);
    onChange();
  });

  /* ---------------- Cart state + drawer ---------------- */
  var cartDrawer = qs("#cart-drawer");
  var cartCountEls = qsa("[data-cart-count]");
  var cartType = document.body.getAttribute("data-cart-type") || "drawer";

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  on(document, "click", "[data-open-cart]", function (e) {
    if (cartType === "drawer") { e.preventDefault(); openCartDrawer(); }
  });
  on(document, "click", "[data-close-cart]", function (e, el) { suppress(e, el); closeCartDrawer(); });

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return;
    fetch(routes.cart_url_prefix + "?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newContent = doc.querySelector("#cart-drawer-content");
        var current = qs("#cart-drawer-content");
        if (newContent && current) current.innerHTML = newContent.innerHTML;
      });
  }

  function cartFetch(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  on(document, "submit", "form[data-add-to-cart-form]", function (e) {
    e.preventDefault();
    var form = e.target;
    var submitBtn = qs("[data-add-to-cart]", form);
    var formData = new FormData(form);
    var payload = { items: [Object.fromEntries(formData)] };
    if (submitBtn) submitBtn.classList.add("btn--loading");
    fetch(routes.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = qs("[data-form-error]", form);
          if (msg) { msg.textContent = res.data.description || "Something went wrong."; msg.hidden = false; }
          return;
        }
        var msg2 = qs("[data-form-error]", form);
        if (msg2) msg2.hidden = true;
        fetch(routes.cart).then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          if (cartType === "drawer") { refreshCartDrawer(); openCartDrawer(); }
        });
      })
      .catch(function (err) {
        var msg = qs("[data-form-error]", form);
        if (msg) { msg.textContent = (err && err.description) || "Something went wrong."; msg.hidden = false; }
      })
      .finally(function () { if (submitBtn) submitBtn.classList.remove("btn--loading"); });
  });

  on(document, "click", "[data-quick-add-form] [data-add-to-cart]", function (e, btn) {
    var form = btn.closest("form");
    if (form && form.hasAttribute("data-add-to-cart-form")) return; // handled by submit listener
  });

  on(document, "click", "[data-cart-remove]", function (e, btn) {
    e.preventDefault();
    var key = btn.getAttribute("data-cart-remove");
    cartFetch(routes.cart_change, { id: key, quantity: 0 }).then(function (cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      if (qs("[data-cart-page]")) window.location.reload();
    });
  });

  on(document, "change", "[data-cart-line-qty]", function (e, input) {
    var key = input.getAttribute("data-cart-line-qty");
    var qty = parseInt(input.value, 10) || 0;
    cartFetch(routes.cart_change, { id: key, quantity: qty }).then(function (cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      if (qs("[data-cart-page]")) window.location.reload();
    });
  });

  /* ---------------- Sticky add-to-cart bar ---------------- */
  var stickyAtc = qs("[data-sticky-atc]");
  var mainAtcForm = qs("[data-add-to-cart-form]");
  if (stickyAtc && mainAtcForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var shown = !entry.isIntersecting;
        stickyAtc.classList.toggle("is-visible", shown);
        document.body.classList.toggle("has-sticky-atc", shown);
      });
    }, { rootMargin: "-120px 0px 0px 0px" });
    observer.observe(mainAtcForm);
    on(stickyAtc, "click", "[data-sticky-atc-submit]", function (e) {
      e.preventDefault();
      mainAtcForm.requestSubmit ? mainAtcForm.requestSubmit() : mainAtcForm.submit();
    });
  }

  /* ---------------- Product gallery ---------------- */
  qsa("[data-product-gallery]").forEach(function (gallery) {
    var main = qs("[data-gallery-main-image]", gallery);
    on(gallery, "click", "[data-gallery-thumb]", function (e, thumb) {
      e.preventDefault();
      qsa("[data-gallery-thumb]", gallery).forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
      if (main) main.src = thumb.getAttribute("data-full-src");
    });
  });

  /* ---------------- Predictive search ---------------- */
  var searchForms = qsa("[data-predictive-search]");
  searchForms.forEach(function (wrapper) {
    var input = qs("input[type='search']", wrapper);
    var resultsBox = qs("[data-search-results]", wrapper);
    var timer;
    if (!input || !resultsBox) return;
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { resultsBox.innerHTML = ""; resultsBox.hidden = true; return; }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              resultsBox.innerHTML = '<p class="text-muted" style="padding:14px;">No results found.</p>';
              resultsBox.hidden = false;
              return;
            }
            resultsBox.innerHTML = products.map(function (p) {
              return '<a class="predictive-search__item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" width="44" height="44">' : "") +
                '<span>' + p.title + '</span></a>';
            }).join("");
            resultsBox.hidden = false;
          });
      }, 250);
    });
    document.addEventListener("click", function (e) {
      if (!wrapper.contains(e.target)) resultsBox.hidden = true;
    });
  });

  on(document, "click", "[data-open-search]", function (e) {
    e.preventDefault();
    var searchModal = qs("#search-modal");
    if (searchModal) {
      searchModal.classList.add("is-open");
      var input = qs("input[type='search']", searchModal);
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  });
  on(document, "click", "[data-close-search]", function (e, el) {
    suppress(e, el);
    var searchModal = qs("#search-modal");
    if (searchModal) searchModal.classList.remove("is-open");
  });

  /* ---------------- Newsletter (AJAX-friendly progressive enhancement) ---------------- */
  qsa("[data-newsletter-form]").forEach(function (form) {
    form.addEventListener("submit", function () {
      window.setTimeout(function () {
        var success = qs("[data-newsletter-success]", form.parentElement);
        if (success) success.hidden = false;
      }, 300);
    });
  });

  /* ---------------- Product recommendations ---------------- */
  qsa("[data-related-products]").forEach(function (el) {
    var productId = el.getAttribute("data-product-id");
    var sectionId = el.getAttribute("data-section-id");
    var limit = el.getAttribute("data-limit") || 8;
    if (!productId || !sectionId) return;
    var url = "/recommendations/products?product_id=" + productId + "&section_id=" + sectionId + "&limit=" + limit + "&intent=related";
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var newEl = doc.querySelector("[data-related-products]");
      if (newEl && newEl.innerHTML.trim() !== "") el.innerHTML = newEl.innerHTML;
    });
  });

  /* ---------------- WhatsApp bubble ---------------- */
  var waWrap = qs("[data-whatsapp-bubble]");
  if (waWrap) {
    var WA_KEY = "tc:whatsapp-dismissed";
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(WA_KEY) === "1"; } catch (err) { dismissed = false; }
    if (!dismissed) waWrap.hidden = false;
    on(waWrap, "click", "[data-dismiss-whatsapp]", function (e) {
      e.preventDefault();
      waWrap.hidden = true;
      try { sessionStorage.setItem(WA_KEY, "1"); } catch (err) { /* private mode: hide for this page only */ }
    });
  }

  /* ---------------- Escape key closes overlays ---------------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeCartDrawer();
      if (mobileMenu) mobileMenu.classList.remove("is-open");
      var searchModal = qs("#search-modal");
      if (searchModal) searchModal.classList.remove("is-open");
    }
  });
})();
